<template>
  <div>
    <a-drawer
      :width="450"
      title="Chỉnh sửa thông tin nhân viên"
      placement="right"
      :visible="visibleUpdateEmployee"
      @close="() => (visibleUpdateEmployee = false)"
      :bodyStyle="{ overflowY: 'auto', maxHeight: 'calc(100% - 100px)' }"
    >
      <UpdateUser
        :updateEmployeeOnView="updateEmployeeOnView"
        :closeDrawerUpdateEmployee="() => (visibleUpdateEmployee = false)"
        :formEmployee="user"
        :loadingItem="loadingItem"
      />
    </a-drawer>
    <a-skeleton :loading="loadingItem" :paragraph="{ rows: 6 }">
      <a-row>
        <a-col :sm="{ span: 24 }" :lg="{ span: 11 }">
          <DisplayDetailUser
            v-if="user"
            :visibleUpdate="toggleVisibleUpdateEmployee"
            :user="user"
          />
        </a-col>
        <a-col :sm="{ span: 24 }" :lg="{ span: 12, offset: 1 }">
          <a-card title="Employee Information">
            <InfoEmployee
              v-if="user && user.employee"
              :employee="user.employee"
            />
          </a-card>
        </a-col>
      </a-row>
    </a-skeleton>
  </div>
</template>
<script>
import UpdateUser from "./updateUser";
import InfoEmployee from "./infoEmployee";
import DisplayDetailUser from "./displayDetailUser";

export default {
  components: { UpdateUser, InfoEmployee, DisplayDetailUser },
  props: {
    loadingItem: {
      type: Boolean,
      default: true,
    },
    user: {
      type: Object,
      default: null,
    },
    updateEmployeeOnView: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      visibleUpdateEmployee: false,
    };
  },
  methods: {
    /**
     * Toggle drawer update Employee on view
     * @param value {boolean}
     */
    toggleVisibleUpdateEmployee(value) {
      this.visibleUpdateEmployee = value;
    },
  },
};
</script>
